module.exports = __webpack_public_path__ + "img/circle-check-box.ddac0d90.svg";